import type { Model } from '@patsnap/tahiti-core';
import type { CheckAccount } from '../type';

export const CheckAccountModel = Symbol.for('CheckAccountModel');

export type CheckAccountModel = Model<CheckAccount>;
